import { render, staticRenderFns } from "./HomeMedicine.vue?vue&type=template&id=1aa70712&scoped=true&"
import script from "./HomeMedicine.vue?vue&type=script&lang=ts&"
export * from "./HomeMedicine.vue?vue&type=script&lang=ts&"
import style0 from "./HomeMedicine.vue?vue&type=style&index=0&id=1aa70712&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa70712",
  null
  
)

export default component.exports